export const GET_CART_LOADING = "get_cart_loading";
export const GET_CART_ERROR = "get_cart_error";
export const GET_CART_SUCCESS = "get_cart_success";
export const ADD_TO_CART = "ADD_TO_CART";
export const DELETE_CART ="DELETE_CART"